import { CreativeDTO } from './CreativeDTO';
import { greaterThanMinimum, hasEndashOrEmDash, rejectedCreativeValidator } from 'src/app/validators/customValidators';
import { Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { GoalType } from '../constants/goal-type.const';
import { BaseDTO, DTOField } from './BaseDTO';
import { Constants } from 'src/app/data/constants/constants.enum';
import { DurationConst } from '../constants/duration.const';


export class CampaignDTO extends BaseDTO {
    fields: DTOField[] = [
        {
            name: 'name',
            type: 'string',
            validators: [Validators.maxLength(225), Validators.required, hasEndashOrEmDash()]
        },
        {
            name: 'startDate',
            type: 'number', //epoch time in milliseconds
            validators: [Validators.required]
        },
        {
            name: 'endDate',
            type: 'number', //epoch time in milliseconds
            validators: [Validators.required]
        },
        {
            name: 'segment',
            type: 'NameValuePairVO'
        },
        {
            name: 'gender',
            type: 'string',
            defaultValue: 'A',
            disabled: true
        },
        {
            name: 'age',
            type: 'string',
            defaultValue: '15+',
            disabled: true
        },
        {
            name: 'languages',
            type: 'Array<string>',
            defaultValue: []
        },
        {
            name: 'genres',
            type: 'Array<string>',
            defaultValue: []
        },
        {
            name: 'channels',
            type: 'Array<string>',
            defaultValue: []
        },
        { //no a visible control
            name: 'excludeChannels',
            type: 'Array<string>',
            defaultValue: []
        },
        {
            name: 'budget',
            type: 'number',
            validators: [Validators.required, greaterThanMinimum(Constants.CAMAPIGN_BUDGET_MINIMUM)]
        },
        {
            name: 'goalType',
            type: 'string',
            defaultValue: GoalType.moreImpressionsGRPs.value
        },
        {
            name: 'autoSelect',
            type: 'boolean',
            defaultValue: false
        },
        {
            name: 'creatives',
            type: 'Array<CreativeVO>',
            defaultValue: [],
            validators: [rejectedCreativeValidator()]
        },
        {
            name: 'produceCreative',
            type: 'formArray',
            arrayClass: CreativeDTO,
            createInitialItem: false
        },
        {
            name: 'videoOptions',
            type: 'Array<any>',
            defaultValue: []
        },
        {
            name: 'videoLanguages',
            type: 'Array<string>',
            defaultValue: []
        },
        {
            name: 'skipCreative',
            type: 'boolean',
            defaultValue: false
        },
        {
            name: 'adDuration',
            type: 'string',
            defaultValue: DurationConst.SECONDS_30.value
        }
    ];

    constructor(fb?: FormBuilder) {
        super(fb);
        if (fb) {
            this.init();
        }
    }
}
